import React, { useEffect, useState } from "react";
import "../styles/TableOfContents.css";

const TableOfContents = () => {
  const [headings, setHeadings] = useState([]);

  useEffect(() => {
    const elements = Array.from(document.querySelectorAll("h2, h3"));
    console.log("Found headings:", elements);

    const tocItems = [];
    let currentH2 = null;

    elements.forEach((el, index) => {
      const id = `toc-${index}`;
      el.setAttribute("id", id);

      if (el.tagName.toLowerCase() === "h2") {
        currentH2 = { id, text: el.textContent, children: [] };
        tocItems.push(currentH2);
      } else if (el.tagName.toLowerCase() === "h3") {
        if (currentH2) {
          currentH2.children.push({ id, text: el.textContent });
        } else {
          tocItems.push({ id, text: el.textContent, children: [] });
        }
      }
    });

    setHeadings(tocItems);
  }, []);

  const scrollToHeading = (id) => {
    const target = document.getElementById(id);
    if (target) {
      window.scrollTo({
        top: target.offsetTop - 20,
        behavior: "smooth",
      });
    }
  };

  return (
    <div className="elt-wp-plugin toc">
      <h4 className="toc-title">目次</h4>
      <ol>
        {headings.length > 0 ? (
          headings.map((heading, index) => (
            <li key={heading.id}>
              <a
                href={`#${heading.id}`}
                className="toc-link"
                onClick={(e) => {
                  e.preventDefault();
                  scrollToHeading(heading.id);
                }}
              >
                {heading.text}
              </a>
              {heading.children.length > 0 && (
                <ol>
                  {heading.children.map((child, childIndex) => (
                    <li key={child.id}>
                      <a
                        href={`#${child.id}`}
                        className="toc-link"
                        onClick={(e) => {
                          e.preventDefault();
                          scrollToHeading(child.id);
                        }}
                      >
                        {`${index + 1}.${childIndex + 1} ${child.text}`}
                      </a>
                    </li>
                  ))}
                </ol>
              )}
            </li>
          ))
        ) : (
          <li>目次が見つかりません。</li>
        )}
      </ol>
    </div>
  );
};

export default TableOfContents;

